import { ReactComponent as ToggleIcon } from 'assets/icons/toggle_on.svg'
import { ReactComponent as PauseCircleIcon } from 'assets/icons/pause_circle.svg'
import { ReactComponent as DraftIcon } from 'assets/icons/message-opened.svg'
import { ReactComponent as MotionIcon } from 'assets/icons/auto_awesome_motion.svg'
import { ReactComponent as PsychologyIcon } from 'assets/icons/psychology.svg'
import { ReactComponent as TravelIcon } from 'assets/icons/travel_explore.svg'
import { ReactComponent as FlagIcon } from 'assets/icons/flag_circle.svg'
import { ReactComponent as AssignmentIcon } from 'assets/icons/assignment-2.svg'
import { ReactComponent as CalendarCheckIcon } from 'assets/icons/calendar_check.svg'
import { ReactComponent as CheckCircleIcon } from 'assets/icons/check-circle.svg'
import { ReactComponent as PauseIcon } from 'assets/icons/pause.svg'
import { ReactComponent as PenIcon } from 'assets/icons/pen.svg'
import { ReactComponent as CrossIcon } from 'assets/icons/cross.svg'
import { ReactComponent as ArrowIcon } from 'assets/icons/arrow_back.svg'
import { ReactComponent as PeopleIcon } from 'assets/icons/people.svg'
import { ReactComponent as AppIcon } from 'assets/icons/app.svg'
import { ReactComponent as CityIcon } from 'assets/icons/city.svg'
import { ReactComponent as PlanetIcon } from 'assets/icons/planet.svg'
import { ReactComponent as UniversityIcon } from 'assets/icons/university.svg'
import { ReactComponent as ClockArrowIcon } from 'assets/icons/clock-arrow.svg'
import { ReactComponent as RoadmapIcon } from 'assets/icons/assignment_turned_in.svg'
import { ReactComponent as ProfileIcon } from 'assets/icons/dock.svg'
import { ReactComponent as DeadlineIcon } from 'assets/icons/calendar_clock.svg'
import { ReactComponent as BookmarksIcon } from 'assets/icons/bookmarks.svg'
import { ReactComponent as LightbulbIcon } from 'assets/icons/lightbulb.svg'
import { ReactComponent as BriefcaseIcon } from 'assets/icons/bag-line.svg'
import { ReactComponent as HistoryIcon } from 'assets/icons/history_edu.svg'

export const PARENT_NOTIFICATION_ICONS = {
	updatesTab: MotionIcon,
	templatesTab: DraftIcon,
	contactsTab: PeopleIcon,
	logsTab: HistoryIcon,
	toggleOn: ToggleIcon,
	pauseCircle: PauseCircleIcon,
	drafts: DraftIcon,
	psychology_alt: PsychologyIcon,
	travel_explore: TravelIcon,
	flag_circle: FlagIcon,
	assignment: AssignmentIcon,
	event_available: CalendarCheckIcon,
	getting_started: AppIcon,
	vision_2030: CityIcon,
	global_citizen: PlanetIcon,
	strategic_shortlist: UniversityIcon,
	personal_statement: AssignmentIcon,
	roadmap_ready: RoadmapIcon,
	profile_unlocked: ProfileIcon,
	deadline_reminder: DeadlineIcon,
	career_selected: BriefcaseIcon,
	university_digest: BookmarksIcon,
	project_digest: LightbulbIcon,
	country_preference: TravelIcon,
	stable_timer: ClockArrowIcon,
	check_circle: CheckCircleIcon,
	pause: PauseIcon,
	edit: PenIcon,
	close: CrossIcon,
	arrow_forward: ArrowIcon,
}

export const getParentNotificationIcon = iconKey =>
	PARENT_NOTIFICATION_ICONS[iconKey] || DraftIcon
